import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { ComplexSuggestedItem } from '../../../../ui/gzComplexEnumList/types';
import { getCompanyExtraFilterForComplexEnumFilterCallback } from '../../../common/utils';
import { DEVICES_CLASS } from '../../../common/constants';

export class VulnerabilitiesAffectedDevices {
  /**
   *
   * @param page
   * @param limit
   * @param searchString
   * @param filters
   * @protected
   */
  static async getRemoteData(page, limit, searchString: string = '', filters: Array<any> = []): Promise<Array<any>> {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'Vulnerabilities',
      method: 'getDevices',
      payload: {
        page,
        limit,
        searchString,
        filters,
      },
    });
  }

  /**
   *
   * @param response
   * @protected
   */
  static convertResponse(response): ComplexSuggestedItem[] {
    return response;
  }

  static getExtraFilters(): Array<any> {
    return getCompanyExtraFilterForComplexEnumFilterCallback('gz-vulnerabilities-app');
  }

  static getTypeToIconMapping(): Map<number, string> {
    return DEVICES_CLASS;
  }
}
